import { MESSAGE_RESPONSE } from '../../Settings/Constants/Constants';

function getSubString(string) {
  if (string !== '') {
    const getSubString = string.indexOf('/', 1);

    if (getSubString === -1) {
      return '';
    }
    const subString = string.slice(getSubString + 1);
    return subString;
  }
  return 'No source';
}

function transformData(data, ids_referencia) {
  const data_variables = {};

  // Convertimos ids_referencia en un objeto para acceso rápido por ID
  const referenceMap = ids_referencia.reduce((acc, item) => {
    acc[item.id] = item.is_mandatory; // Guardamos solo la propiedad is_mandatory con el id como clave
    return acc;
  }, {});

  Object.entries(data).forEach(([key, value]) => {
    if (!isNaN(key)) {
      data_variables[key] = {
        value,
        is_mandatory: referenceMap[key] ?? false // Si existe en el mapa, usa su valor, si no, asigna false
      };
    }
  });

  return {
    ...data,
    data_variables
  };
}

const handleMessage = (message, parameters) => {
  switch (message) {
    case MESSAGE_RESPONSE.MSG_EQUAL_EMAIL:
      return parameters?.MSG_EQUAL_EMAIL?.value || 'Your user can not be a reference';
    case MESSAGE_RESPONSE.USER_EMAIL_SOME_USER:
      return parameters?.USER_EMAIL_SOME_USER?.value || 'Your user email can not be a reference';
    case MESSAGE_RESPONSE.SOME_USER_ID:
      return parameters?.SOME_USER_ID?.value || 'same user id';
    case MESSAGE_RESPONSE.REFERENCE_SUCCCESS_DELETE:
      return parameters?.REFERENCE_SUCCCESS_DELETE?.value || 'User reference eliminado con éxito';

    case MESSAGE_RESPONSE.REFERENCE_WITH_ENRROLLMENT:
      return parameters?.REFERENCE_WITH_ENRROLLMENT?.value || 'User reference with enrollment';
    case MESSAGE_RESPONSE.REFERENCE_PROTECTE:
      return parameters?.REFERENCE_PROTECTE?.value || 'Cannot delete protection constraints';
    case MESSAGE_RESPONSE.REFERENCE_CANNOT_DELETE:
      return (
        parameters?.REFERENCE_CANNOT_DELETE?.value ||
        'Cannot delete some instances of model UserRole Userphone User'
      );
    case MESSAGE_RESPONSE.USER_PHONE_EXISTE:
      return parameters?.USER_PHONE_EXISTE?.value || 'user phone already exists';
    default:
      break;
  }
};

export { getSubString, transformData, handleMessage };
